module.exports = __webpack_public_path__ + "media/images/assignment/link_off_gray-67a8d3a07cae4f2e8fc07543b83276f0.svg";